import { Navigate, useLocation } from 'react-router';
import { useCanViewAllTenants } from '../common/useCanViewAllTenants';
import { useIsMaster } from '../common/useIsMaster';
import { masterModeEntryPath } from '../common/masterModeEntry';

/**
 * Index-route landing — the start page after login. Users with the
 * all-tenant view open the admin UI in that view, not in whichever tenant
 * happens to be restored from their last visit; a master opens on
 * "Mandanten" (PO, 2026-11-02, `masterModeEntryPath`).
 *
 * Only `/` resolves here, so a deep link (any other path) is never
 * redirected. An explicit tenant pick (`useSwitchTenant`) passes
 * `skipMasterLanding` so it lands on the tenant's default page instead of
 * bouncing straight back to the all-tenant view.
 */
const DefaultLanding = ({ fallbackPath }: { fallbackPath: string }) => {
    const canViewAllTenants = useCanViewAllTenants();
    const isMaster = useIsMaster();
    const location = useLocation();
    const skipMasterLanding =
        (location.state as { skipMasterLanding?: boolean } | null)
            ?.skipMasterLanding === true;
    const target = canViewAllTenants && !skipMasterLanding
        ? masterModeEntryPath(isMaster)
        : fallbackPath;
    return <Navigate to={target} replace={true} />;
};

export default DefaultLanding;
